import get from 'lodash/get';
import { call, put, select, takeEvery } from 'redux-saga/effects';
import { constants as crewUserDetailsConstants } from '../crew-user-details/redux';
import { addSuccess, addError } from '../notifications/actions';
import { actions, constants } from './redux';
import Api from '../../utils/Api';

export function* fetchItems({ payload }) {
  try {
    yield put(actions.loadItemRequest());

    const data = yield call(Api.vacancyContacts.forClient, payload.id);

    yield put(actions.addItems(data));
  } catch (e) {
    console.error(e);

    yield put(actions.loadItemsError(e));
  }
}

export function* createItem({ payload: option }) {
  try {
    const crewUserId = yield select((s) => s.crewUserDetails.data.id);
    const item = yield call(Api.vacancyContacts.createForClient, option.value, crewUserId);

    yield put(actions.addCreatedItem(item));
    yield put(addSuccess(`The user is now a vacancy ad contact for ${option.label}`));
  } catch (e) {
    console.error(e);

    if (get(e, 'apiErrors[0].status') === '422') {
      yield put(addError(`The user is already a vacancy ad contact for ${option.label}`));
    }

    yield put(actions.createItemError(e));
  }
}

export function* deleteItem({ payload: id }) {
  try {
    yield call(Api.vacancyContacts.delete, id);

    yield put(actions.deleteItem(id));
    yield put(addSuccess('Removed from the owner\'s vacancy ad contacts'));
  } catch (e) {
    yield put(actions.deleteItemError(e));
  }
}

/**
 * getFeatureSagas
 * each saga file should return all feature sagas
 * @returns {ForkEffect[]}
 */
export default function getFeatureSagas() {
  return [
    takeEvery(constants.CREATE_ITEM_REQUEST, createItem),
    takeEvery(constants.DELETE_ITEM_REQUEST, deleteItem),
    takeEvery(crewUserDetailsConstants.ADD_LOADED_ITEM, fetchItems),
  ];
}
